<div class="flex flex-auto w-full flex-col items-center p-4 sm:flex-row sm:items-start">
  <div class="flex h-10 w-10 flex-0 items-center justify-center rounded-full sm:mr-4 bg-blue-100 text-blue-600 dark:bg-blue-600 dark:text-blue-50'">
    <mat-icon class="text-current" svgIcon="heroicons_outline:exclamation-triangle"></mat-icon>
  </div>
  <div class="w-full mt-4 flex flex-col items-center space-y-1 text-center sm:mt-0 sm:items-start sm:pr-8 sm:text-left">
    <h2 class="text-xl font-bold leading-6" mat-dialog-title>{{configData.title}}</h2>
    <mat-dialog-content class="p-0 w-full">
      <div class="w-full">
        <mat-label class="text-xs">{{configData.description}}</mat-label>
        <textarea class="border w-full p-4 text-sm" required name="comentarios" id="comentarios" placeholder="Ingrese la razón de la acción" [(ngModel)]="comentarios"></textarea>
      </div>
    </mat-dialog-content>
    <mat-dialog-actions class="flex flex-row items-end w-full justify-end">
      <button mat-raised-button (click)="close()"  >Cancelar</button>
      <button mat-raised-button (click)="confirmed()" [disabled]="this.comentarios.length == 0">Confirmar</button>
    </mat-dialog-actions>
  </div>
</div>

